import { EntityKey } from 'constants/index';
import { ElevatorCoordinatesState } from './types';

export const elevatorCoordinatesSelector = (state): ElevatorCoordinatesState =>
    state.entities[EntityKey.ELEVATOR_COORDINATES];

export const coordinatesSelector = (state): ElevatorCoordinatesState =>
    state.entities[EntityKey.ELEVATOR_COORDINATES].coordinates;
